import axios from "axios";
import { f7 } from "framework7-vue";

const axiosParams = {
  baseURL: "https://hausaufgaben.suetti.it/api",
  withCredentials: true,
  timeout: 15000,
  headers: {
    "X-DEV": "suetti.it",
    "X-CODE": ""
  }
};

const code = localStorage.getItem("code");
if (code) axiosParams.headers["X-CODE"] = code;
// if (JWT) axiosParams.headers['Authorization'] = 'Bearer' + JWT;
const Api = axios.create(axiosParams);

Api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status == 500) {
      (f7 as any).toast
        .create({
          text: "Fehler",
          position: "top",
          cssClass: "error",
          closeTimeout: 3000
        })
        .open();
    }
    if (error.response.status == 401) {
      localStorage.removeItem("code");
      (f7 as any).emit("logout");
    }
    return Promise.reject(error);
  }
);

export default Api;
